import './ucsc/style';
import FormStructure from './ucsc/form_structure';

export default FormStructure;